/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promos_HintInputs */



/**
* | output |
* | --- |
* | "Copies handed out at this event — saved automatically." |
*
* @param {Promos_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promos_hint = /** @type {((inputs?: Promos_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promos_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Copies distribuées lors de cet événement — enregistrées automatiquement.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Copias distribuidas en este evento — guardadas automáticamente.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Cópias distribuídas neste evento — salvas automaticamente.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Copie distribuite a questo evento — salvate automaticamente.")
	return /** @type {LocalizedString} */ ("Copies handed out at this event — saved automatically.")
});